module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Hi Hat Normal-883bfb32da5d0d942bb3e703180ba02d.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Hi Hat Normal.mp3
// module id = 67
// module chunks = 0